"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSolanaNFTs = useSolanaNFTs;
var react_1 = require("react");
var solana_headless_core_1 = require("@hermis/solana-headless-core");
var useConnection_1 = require("./useConnection");
var useWallet_1 = require("./useWallet");
/**
 * Hook for fetching NFTs owned by an address
 *
 * @param owner Optional owner address (defaults to connected wallet)
 * @returns Object with NFTs and loading state
 */
function useSolanaNFTs(owner) {
    var _this = this;
    var dualConnection = (0, useConnection_1.useConnection)().connection;
    // Cast to legacy Connection for existing code compatibility
    var connection = dualConnection;
    var publicKey = (0, useWallet_1.useWallet)().publicKey;
    var _a = (0, react_1.useState)([]), nfts = _a[0], setNfts = _a[1];
    var _b = (0, react_1.useState)(false), loading = _b[0], setLoading = _b[1];
    var _c = (0, react_1.useState)(null), error = _c[0], setError = _c[1];
    var ownerAddress = owner || publicKey;
    var fetchNFTs = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var tokenAccounts, potentialNFTs, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!ownerAddress) {
                        setNfts([]);
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, connection.getParsedTokenAccountsByOwner(ownerAddress, { programId: new solana_headless_core_1.PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA') })];
                case 2:
                    tokenAccounts = (_a.sent()).value;
                    potentialNFTs = tokenAccounts
                        .filter(function (account) {
                        var amount = account.account.data.parsed.info.tokenAmount;
                        return amount.decimals === 0 && amount.uiAmount === 1;
                    })
                        .map(function (account) { return ({
                        mint: new solana_headless_core_1.PublicKey(account.account.data.parsed.info.mint),
                        tokenAccount: account.pubkey,
                        metadata: null,
                        uri: null
                    }); });
                    setNfts(potentialNFTs);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.error('Error fetching NFTs:', err_1);
                    setError(err_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [connection, ownerAddress]);
    (0, react_1.useEffect)(function () {
        fetchNFTs();
    }, [fetchNFTs]);
    return {
        nfts: nfts,
        loading: loading,
        error: error,
        refetch: fetchNFTs
    };
}
